/** 받은 날·저장 시각 — SE 는 날짜만, SU 는 시각까지(로캘 형식). 형식이 틀리면 빈 문자열. */
export function formatWhen(iso: string, locale: string, withTime: boolean): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return new Intl.DateTimeFormat(locale === "ko" ? "ko-KR" : "en-US", {
    month: "numeric",
    day: "numeric",
    ...(withTime ? { hour: "2-digit", minute: "2-digit", hour12: false } : {}),
  }).format(d);
}
